import ActionTypes from "./actionTypes";
import { getAppStore } from "../../store";
import { DealerGroup } from "../../../models/Organization/DealerGroup";
import { LOCAL_STORAGE_KEYS } from "../../../constants/appVars";

export class DGroupStoreActions {
    static loadingOrganizations(loading: boolean) {
        getAppStore().dispatch({ type: ActionTypes.LOADING_DEALERGROUPS, payload: loading });
    }
    static saveOrganizations(orgs: DealerGroup[]) {
        getAppStore().dispatch({ type: ActionTypes.SAVE_DEALERGROUPS, payload: orgs });
    }
    static getOrganizations() {
        return getAppStore().getState().dealerGroups.orgs;
    }
    static getActiveOrg() {
        return getAppStore().getState().dealerGroups.activeOrg;
    }
    static setActiveOrg(org: DealerGroup) {
        localStorage.setItem(LOCAL_STORAGE_KEYS.ACTIVE_DEALER_GROUP, org.id);
        getAppStore().dispatch({ type: ActionTypes.SET_ACTIVE_DEALERGROUP, payload: org });
    }
    static getSavedOrgId() {
        return localStorage.getItem(LOCAL_STORAGE_KEYS.ACTIVE_DEALER_GROUP);
    }
}
